import { IconButton } from '@atlaskit/button/new';
import TrashIcon from '@atlaskit/icon/core/migration/delete--trash';
import Tooltip from '@atlaskit/tooltip';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../../i18n';

interface DeleteViewButtonProps {
  onDelete: () => void;
}

const DeleteViewButton: FunctionComponent<DeleteViewButtonProps> = ({ onDelete }) => {
  const { formatMessage } = useIntl();

  return (
    <Tooltip
      content={formatMessage(messages['view-settings-panel.delete'])}
      testId="view-settings-panel-delete-tooltip"
    >
      {(tooltipProps) => (
        <IconButton
          {...tooltipProps}
          appearance="subtle"
          icon={TrashIcon}
          label={formatMessage(messages['view-settings-panel.delete'])}
          onClick={onDelete}
          testId={'view-settings-panel-delete-button'}
        />
      )}
    </Tooltip>
  );
};

export default DeleteViewButton;
